import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";

// src/components/form-control/form-control-renderer.ts
import { t } from "i18next";
var FormElementRenderer = class {
  constructor(parent, type, inputGetter) {
    this.parent = parent;
    this.type = type;
    this.inputGetter = inputGetter;
    this.validators = [];
  }
  get formControl() {
    const input = this.inputGetter();
    return input == null ? void 0 : input.closest(".form-control");
  }
  get invalid() {
    var _a, _b;
    return (_b = (_a = this.formControl) == null ? void 0 : _a.classList.contains("form-control--has-error")) != null ? _b : false;
  }
  set invalid(value) {
    var _a;
    (_a = this.formControl) == null ? void 0 : _a.classList.toggle("form-control--has-error", value);
  }
  get focused() {
    var _a, _b;
    return (_b = (_a = this.formControl) == null ? void 0 : _a.classList.contains("form-control--has-focus")) != null ? _b : false;
  }
  set focused(value) {
    var _a, _b;
    (_a = this.formControl) == null ? void 0 : _a.classList.toggle("form-control--has-focus", value);
    if (this.type === "select") {
      (_b = this.formControl) == null ? void 0 : _b.classList.toggle("select--open", value);
    }
  }
  connect() {
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    const input = this.inputGetter();
    input.addEventListener("blur", this.handleBlur);
    input.addEventListener("focus", this.handleFocus);
    input.addEventListener("change", this.handleChange);
  }
  disconnect() {
    const input = this.inputGetter();
    input.removeEventListener("blur", this.handleBlur);
    input.removeEventListener("focus", this.handleFocus);
    input.removeEventListener("change", this.handleChange);
  }
  addValidator(validator) {
    this.validators.push(validator);
  }
  handleBlur() {
    this.focused = false;
    this.invalid = this.touched && this.validators.some((x) => x());
    emit(this.parent, "sl-blur");
  }
  handleFocus() {
    if (this.parent.disabled)
      return;
    this.focused = true;
    this.touched = true;
    emit(this.parent, "sl-focus");
  }
  handleChange() {
    var _a;
    (_a = this.formControl) == null ? void 0 : _a.classList.toggle("select--open", false);
  }
  renderFloatingLabel(options) {
    if (!this.parent.floating)
      return w;
    return this.renderLabel(options);
  }
  renderStandardLabel(options) {
    if (this.parent.floating)
      return w;
    return this.renderLabel(options);
  }
  renderLabel(options) {
    return $`<label part="label" id=${l(options.labelId)} class="form-control__label" for=${options.labelFor} title="${options.label}" aria-hidden=${options.label ? "false" : "true"} >${options.label}</label>`;
  }
  renderHelpText(options) {
    if (!options.helpText)
      return w;
    return $`<div part="help-text" id=${l(options.helpTextId)} class="form-control__help-text">${options.helpText}</div>`;
  }
  renderClearable(options) {
    if (!options.clearable)
      return w;
    return $`<button aria-label=${t("components:common.clearEntry")} part="clear-button" class="input__clear" type="button" tabindex="-1" @click=${() => emit(this.inputGetter(), "form-element-cleared")} ><fadv-icon name="circle-xmark" library="solid"></fadv-icon></button>`;
  }
  renderSelectIcon() {
    if (this.type !== "select")
      return w;
    return $`<span part="icon" class="select__icon" aria-hidden="true"><fadv-icon name="chevron-down" library="system"></fadv-icon></span>`;
  }
  render(input, options, prefix, suffix) {
    return $`<div class=${o({
      "form-control": true,
      "form-control-renderer": true,
      "form-control--standard": !this.parent.floating,
      "form-control--floating": this.parent.floating,
      "form-control--has-label": !!options.label,
      "form-control--has-help-text": !!options.helpText,
      "form-control--has-prefix": !!prefix,
      "form-control--has-suffix": !!suffix,
      "form-control--pill": this.parent.pill,
      "form-control--has-value": !!options.hasValue,
      "form-control--disabled": !!options.disabled || !!this.parent.disabled,
      "form-control--readonly": !!options.disabled || !!this.parent.readonly,
      "form-control--primary": !this.parent.variant || this.parent.variant === "primary",
      "form-control--secondary": this.parent.variant === "secondary",
      "form-control--tertiary": this.parent.variant === "tertiary",
      "form-control--monochrome": this.parent.variant === "monochrome"
    })} >${this.renderStandardLabel(options)}<div class="form-control__container"><div class="form-control__border-exterior"><div part="base" class="form-control__border-interior"><span part="prefix" class="form-control__control--prefix">${prefix || ""}</span><div class="form-control__control-host">${this.renderFloatingLabel(options)}${input}</div>${this.renderClearable(options)}<span part="suffix" class="form-control__control--suffix">${suffix || ""}${this.renderSelectIcon()}</span></div></div></div>${this.renderHelpText(options)}</div>`;
  }
};

export {
  FormElementRenderer
};
